<template>
  <div>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='col-lg-12' style='padding:0px'>
        <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='errorShow'>
          <ul v-if='validationErrors'>
            <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
          </ul>
        </div>
        <div class='alert alert-success alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='successShow'>
          {{success}}
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
          <span>العقد:</span>
          <select @change='FillGrid()' class="form-control" style="padding: 0px" v-model="record.contract_id">
            <option v-for="contract in $store.state.customerData.contract" v-bind:key="contract.id" v-bind:value="contract.id">
              {{contract.item}} [{{ contract.id }}]
            </option>
          </select>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
          <span>الصنف:</span>
          <select class="form-control" style="padding: 0px" v-model="record.item_id">
            <option v-for="item in contractItems" v-bind:key="item.id" v-bind:value="item.id">
              {{ item.item }}
            </option>
          </select>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
          <span>التاريخ الافتراضى:</span>
          <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='record.default_date'></Datepicker>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 0px;'>
          <span>تاريخ التغيير:</span>
          <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='record.change_date'></Datepicker>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
          <span>المبلغ:</span>
          <input  @keypress="isNumber($event)"  v-model='record.amount' class='form-control' name='amount' type='text'>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
          <span>المدفوع:</span>
          <input  @keypress="isNumber($event)" v-model='record.paid' class='form-control' name='amount' type='text'>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
          <span>الخزنة:</span>
          <select class="form-control" style="padding: 0px" v-model="record.treasury_id">
            <option v-for="treasury in treasuries" v-bind:key="treasury.id" v-bind:value="treasury.id">
              {{ treasury.name }}
            </option>
          </select>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 10px 0px;'>
          <span>الفنى:</span>
          <select class="form-control" style="padding: 0px" v-model="record.technical_id">
            <option v-for="technical in technicals" v-bind:key="technical.id" v-bind:value="technical.id">
              {{ technical.name }}
            </option>
          </select>
        </div>
        <div class='col-lg-3 col-sm-3' style='padding: 0px 0px 10px 10px;'>
          <span>المخزن:</span>
          <select class="form-control" style="padding: 0px" v-model="record.store_id">
            <option v-for="store in stores" v-bind:key="store.id" v-bind:value="store.id">
              {{ store.name }}
            </option>
          </select>
        </div>
          <div class='col-lg-6 col-sm-6' style='padding: 0px 0px 10px 10px;'>
          <span>العروض:</span>
          <select  @change="chooseOffer($event.target.value)" class="form-control" style="padding: 0px" v-model="offer_id">
            <option  v-for="offer in offers" v-bind:key="offer.id"  v-bind:value="offer.id">
              {{offer.offer_name}} - {{offer.price}}
            </option>
          </select>
          </div>
          <div class='col-lg-3 col-sm-3' style='padding: 21px 2px 0px 0px;'>
          <button v-show="$per.value.saveMaintenance" @click='saveOffer()'  type='button' class='btn btn-primary btn-outline btn-sm btn-block'>حفظ العرض</button>
        </div>
        <div class='col-lg-12 col-sm-12' style='padding: 0px 0px 10px 0px;'>
          <span>ملاحظات:</span>
          <input  v-model='record.notes' class='form-control' name='notes' type='text'>
        </div>
        <div class='col-lg-4 col-sm-4  col-lg-offset-4  col-sm-offset-4' style='padding: 0px 0px 10px 0px;text-align:center;'>
          <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
          <button v-show="$per.value.saveMaintenance" @click='showForm(0)'  type='button' class='btn btn-primary btn-outline btn-sm'>جديد</button>
          <button v-show="($per.value.saveMaintenance && record.id === 0 ) || ($per.value.editMaintenance && record.id > 0 )" @click='saveData'  type='button' class='btn btn-outline btn-sm btn-success'>حفظ</button>
          <button v-show="$per.value.deleteMaintenance" @click='deleteData(selectedrec)' type='button' class='btn btn-outline btn-danger btn-sm'>حذف</button>
        </div>
        <div class='col-lg-12 col-sm-12' style='padding: 0px 0px 0px 0px;text-align:right;'>
          <button @click='changeView()'  type='button' class='btn btn-primary btn-outline btn-sm'>{{btnTitle}}</button>
        </div>
        <table width='100%' class='table  table-bordered ' >
          <thead>
            <tr>
              <th style='text-align: center'>الصنف</th>
              <th style='text-align: center'>ت الافتراضى</th>
              <th style='text-align: center'>ت التغيير</th>
              <th style='text-align: center'>المبلغ</th>
              <th style='text-align: center'>المدفوع</th>
              <th style='text-align: center'>الرصيد</th>
              <th style='text-align: center'>فنى التركيب</th>
              <th style='text-align: center'>ملاحظات</th>
            </tr>
          </thead>
          <tbody v-show="!$per.value.editMaintenance">
            <tr v-show="showAll || !record.change_date" v-for='record in records' :key='record.id'>
              <td v-bind:style="{ 'background-color': record.color}" align='center'>{{record.item}}</td>
              <td v-bind:style="{ 'background-color': record.color}" align='center'>{{record.default_date}}</td>
              <td v-bind:style="{ 'background-color': record.color}" align='center'>{{record.change_date}}</td>
              <td v-bind:style="{ 'background-color': record.color}" align='center'>{{record.amount}}</td>
              <td v-bind:style="{ 'background-color': record.color}" align='center'>{{record.paid}}</td>
              <td v-bind:style="{ 'background-color': record.color}" align='center'>{{record.balance}}</td>
              <td v-bind:style="{ 'background-color': record.color}" align='center'>{{record.technical_name}}</td>
              <td v-bind:style="{ 'background-color': record.color}" align='right'>{{record.notes}}</td>
            </tr>
          </tbody>
          <tbody v-show="$per.value.editMaintenance">
            <tr v-show="showAll || !record.change_date" :class="{highlight :selectedrec == record.id}"  v-for='record in records' :key='record.id' v-on:click="showForm(record)">
              <td v-bind:style="{ 'background-color': record.color}" align='center'>{{record.item}}</td>
              <td v-bind:style="{ 'background-color': record.color}" align='center'>{{record.default_date}}</td>
              <td v-bind:style="{ 'background-color': record.color}" align='center'>{{record.change_date}}</td>
              <td v-bind:style="{ 'background-color': record.color}" align='center'>{{record.amount}}</td>
              <td v-bind:style="{ 'background-color': record.color}" align='center'>{{record.paid}}</td>
              <td v-bind:style="{ 'background-color': record.color}" align='center'>{{record.balance}}</td>
              <td v-bind:style="{ 'background-color': record.color}" align='center'>{{record.technical_name}}</td>
              <td v-bind:style="{ 'background-color': record.color}" align='right'>{{record.notes}}</td>
            </tr>
          </tbody>
        </table>
        <!-- /.table-responsive -->
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>
<style>
.highlight {
   background-color: #5A9EF5;
}
tr:hover{
   cursor: pointer;
}
</style>
<script>
import axios from 'axios'
import Datepicker from 'vuejs-datepicker'
import {ar} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
export default {
  components: {
    Datepicker
  },
  name: 'maintenance',
  data () {
    return {
      ar: ar,
      validationErrors: '',
      records: {},
      record: {},
      offers: {},
      offer_id: 0,
      treasuries: {},
      items: {},
      technicals: {},
      stores: {},
      btnTitle: 'عرض الكل',
      showAll: true,
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      Localcontract_id: 0,
      isLoadingDelete: false,
      branches: {},
      selectedrec: null
    }
  },
  computed: {
    contractItems () {
      return this.items.filter(item => item.is_contract === 0)
    }
  },
  created () {
    this.items = JSON.parse(localStorage.getItem('Items'))
    this.getActiveOffers()
  },
  methods: {
    UpdateData (id) {
      this.branches = JSON.parse(localStorage.getItem('Branches'))
      let i = this.branches.findIndex(x => x.id === parseInt(id))
      if (i > -1) {
        this.treasuries = this.branches[i].treasuries
        this.technicals = this.branches[i].technicals
        this.stores = this.branches[i].stores
      }
      this.getActiveOffers()
    },
    getActiveOffers () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'getActiveOffers', {
        token: localStorage.getItem('token'),
        branch_id: this.$store.state.customerData.branche_id
      })
        .then(res => {
          this.isLoadingSave = false
          this.offers = res.data
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    GetData () {
      this.errorShow = false
      this.successShow = false
      this.isLoadingSave = false
      // -----------------------------------------------------
      this.UpdateData(this.$store.state.customerData.branche_id)
      this.record = {}
      this.showForm(0)
      this.records = this.$store.state.customerData.maintenance
    },
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    isLocked: function (evt) {
      evt.preventDefault()
    },
    FillGrid (RecID) {
      let i = this.$store.state.customerData.contract.findIndex(x => x.id === this.record.contract_id)
      this.records = this.$store.state.customerData.contract[i].maintenance
    },
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      if (recID === 0) {
        this.Localcontract_id = this.record.contract_id
        this.selectedrec = 0
        this.record = {'id': 0, 'contract_id': '', 'item_id': '', 'amount': '', 'paid': '', 'treasury_id': '', 'user_id': '', 'technical_id': '', 'store_id': '', 'notes': '', 'balance': 0}
        this.record.contract_id = this.Localcontract_id
      } else {
        this.selectedrec = recID.id
        this.record = recID
      }
    },
    changeView () {
      this.showAll = !this.showAll
      if (!this.showAll) {
        this.btnTitle = 'عرض الكل'
      } else {
        this.btnTitle = 'عرض الغير منفذ'
      }
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveMaintenance', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        uid: this.record.uid,
        contract_id: this.record.contract_id,
        item_id: this.record.item_id,
        default_date: this.record.default_date,
        change_date: this.record.change_date,
        amount: this.record.amount,
        paid: this.record.paid,
        treasury_id: this.record.treasury_id,
        technical_id: this.record.technical_id,
        branch_id: this.$store.state.customerData.branche_id,
        store_id: this.record.store_id,
        customer_id: this.$store.state.customerData.id,
        notes: this.record.notes
      })
        .then(res => {
          this.isLoadingSave = false
          this.$root.$emit('Update_Totals', this.$store.state.customerData.id, res.data.totals[0].ind, res.data.totals[0].mai, res.data.totals[0].total, res.data.data[0].contract_id, res.data.totals[0].balance)
          let i = this.$store.state.customerData.contract.findIndex(x => x.id === this.record.contract_id)
          this.$store.state.customerData.contract[i].maintenance = res.data.data
          this.records = res.data.data
          this.isLoadingSave = false
          this.errorShow = false
          if (this.record.id !== 0) {
            let r = this.records.findIndex(x => x.id === this.record.id)
            this.record = this.records[r]
            this.showForm(this.record)
            this.selectedrec = this.record.id
          } else {
            this.showForm(0)
          }
          this.success = 'تم الحفظ بنجاح'
          this.successShow = true
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    saveOffer () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveOffer', {
        token: localStorage.getItem('token'),
        contract_id: this.record.contract_id,
        change_date: this.record.change_date,
        treasury_id: this.record.treasury_id,
        technical_id: this.record.technical_id,
        store_id: this.record.store_id,
        offer_id: this.offer_id
      })
        .then(res => {
          this.isLoadingSave = false
          let i = this.$store.state.customerData.contract.findIndex(x => x.id === this.record.contract_id)
          this.$store.state.customerData.contract[i].maintenance = res.data.data
          this.records = res.data.data
          this.isLoadingSave = false
          this.errorShow = false
          if (this.record.id !== 0) {
            let r = this.records.findIndex(x => x.id === this.record.id)
            this.record = this.records[r]
            this.showForm(this.record)
            this.selectedrec = this.record.id
          } else {
            this.showForm(0)
          }
          this.success = 'تم الحفظ بنجاح'
          this.successShow = true
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData (recID) {
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'deleteMaintenance', {
        token: localStorage.getItem('token'),
        id: recID,
        customer_id: this.$store.state.customerData.id
      })
        .then(res => {
          this.$root.$emit('Update_Totals', this.$store.state.customerData.id, res.data.totals[0].ind, res.data.totals[0].mai, res.data.totals[0].total, res.data.data[0].contract_id, res.data.totals[0].balance)
          let i = this.$store.state.customerData.contract.findIndex(x => x.id === this.record.contract_id)
          this.$store.state.customerData.contract[i].maintenance = res.data.data
          this.records = res.data.data
          this.isLoadingDelete = false
          this.errorShow = false
          this.successShow = false
          this.showForm(0)
        })
        .catch(err => {
          if (err.response.data.errors === 'id not found') {
            this.validationErrors = {errors: 'عفوا يرجى اختيار سجل لحذفه'}
            this.isLoadingDelete = false
            this.errorShow = true
          }
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/myComponents/GoogleLogin.vue